import styled from 'styled-components';

export const LegalPageContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: white;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: #333;

  h1 {
    color: #2c3e50;
    margin-bottom: 30px;
    font-size: 2.8em;
    text-align: center;
    background: linear-gradient(135deg, #ff8c42 0%, #ff6b35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  h2 {
    color: #34495e;
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 1.8em;
    border-bottom: 2px solid #fff5f0;
    padding-bottom: 10px;
  }

  h3 {
    color: #2c3e50;
    margin-top: 25px;
    margin-bottom: 15px;
    font-size: 1.3em;
  }

  p {
    margin-bottom: 15px;
    color: #5a6c7d;
  }

  ul, ol {
    margin-bottom: 20px;
    padding-left: 20px;
    color: #5a6c7d;
    
    li {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 15px;
    h1 {
      font-size: 2em;
    }
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #ff8c42;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  padding: 0;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateX(-5px);
  }
`;

export const LegalHighlightBox = styled.div`
  background: #fff5f0;
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #ff8c42;
  margin: 25px 0;

  h3 {
    margin-top: 0;
    color: #ff8c42;
  }

  p {
    margin-bottom: 0;
    font-weight: 500;
  }
`;

export const LegalSection = styled.div`
  margin-bottom: 40px;
`;

export const ContactBox = styled.div`
  margin-top: 60px;
  padding: 40px;
  background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
  border-radius: 20px;
  text-align: center;
  border: 1px solid #feece2;

  h2 {
    margin-top: 0;
    border: none;
  }

  .methods {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 30px;
    flex-wrap: wrap;
  }

  .method {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    span {
      font-weight: 600;
      color: #2c3e50;
    }

    a {
      color: #ff8c42;
      text-decoration: none;
      font-size: 1.1em;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
